import { all, takeEvery, put, call } from "redux-saga/effects";
import { notification } from "antd";
import {history} from '../../../index'
import * as firebase from "../../firebase";
import actions from "./actions";

const mapAuthProviders = {
  firebase: {
    register: firebase.register,
    logout: firebase.logout,
  },
};

export function* REGISTER({ payload }) {
  yield put({
    type: "user/SET_STATE",
    payload: {
      loading: true,
    },
  });
  const result = yield call(
    mapAuthProviders.firebase.register,
    { ...payload }
  );

  if (result.success) {
    yield history.push("/auth/login");
    yield call(mapAuthProviders.firebase.logout);

    notification.success({
      message: "Succesful Registered",
      description: "You have successfully registered!",
    });
  } else {
    notification.error({
      message: result.message.code,
      description: result.message.message
    })
  }

}

export function* LOGOUT() {
  yield call(mapAuthProviders.firebase.logout);
  yield put({
    type: "user/SET_STATE",
    payload: {
      id: "",
      name: "",
      role: "",
      email: "",
      avatar: "",
      authorized: false,
      loading: false,
      users: []
    },
  });
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.REGISTER, REGISTER),
    takeEvery(actions.LOGOUT, LOGOUT),
  ]);
}
